<template>
  <div class="container">
    <a-spin tip="Loading..." :spinning="spinning">
      <a-form-model
        ref="addForm"
        :model="formObject"
        :rules="rules"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-card :title="formName" size="small" :bodyStyle="{ padding: '1px' }">
          <template slot="extra">
            <a-button :style="{ marginRight: '8px' }" @click="onClose">返回</a-button>
            <a-button
              :loading="isLoading"
              :style="{ marginRight: '8px' }"
              type=""
              @click="saveDraft"
              v-if="query.type != 1 && query.type != 4"
            >
              保存
            </a-button>
            <a-button
              :loading="isLoading"
              :style="{ marginRight: '8px' }"
              type=""
              @click="updateSaveDraft"
              v-if="query.type == 1"
            >
              保存
            </a-button>
            <a-button
              type="primary"
              :loading="isLoading"
              @click="handleSubmit"
              v-if="Number(query.type) !== 1 && Number(query.type) !== 4"
            >
              提交
            </a-button>
            <a-button type="primary" @click="handleSubmit2" v-if="query.type == 1">
              提交
            </a-button>
            <a-button type="primary" @click="handleSubmit3" v-if="query.type == 4">
              提交
            </a-button>
          </template>
        </a-card>
        <a-row style="position: relative">
          <div
            style="
              position: absolute;
              right: 0px;
              top: 0px;
              z-index: 2;
              height: calc(100vh - 160px);
            "
            v-if="query.type != 0"
          >
            <div class="sliderbar-off" @click="clickChange">
              <a-icon :type="sliderbar ? 'double-right' : 'double-left'" />
              流转记录
            </div>
            <div :class="!sliderbar ? 'right-close' : 'right-open'" v-show="sliderbarShow">
              <div
                style="
                  background: #fff;
                  width: 100%;
                  height: 100%;
                  border-left: 1px solid #e6e6e6;
                  border-top: 1px solid #e6e6e6;
                "
              >
                <a-card :bordered="false" class="right-card" title="审批记录" size="small">
                  <div class="flow">
                    <a-timeline>
                      <a-timeline-item
                        v-for="(item, index) in displayFlowList"
                        :key="index"
                        :color="getCircleColor(item)"
                      >
                        <p>{{ item.taskName }}</p>
                        <el-card :body-style="{ padding: '10px' }">
                          <!-- 普通节点展示 -->
                          <div v-if="!item.multiInstance" class="div-class">
                            <label v-if="item.assigneeName" style="font-weight: normal; margin-right: 30px; display: flex; align-items: center">
                              <div style="margin-right: 5px">实际办理： {{ item.assigneeName }}</div>
                              <el-popover trigger="hover" placement="top">
                                <p>{{ item.deptName }}</p>
                                <template slot="reference" class="name-wrapper">
                                  <el-tag type="info" size="mini" style="cursor: pointer; max-width: 200px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
                                    {{ item.deptName }}
                                  </el-tag>
                                </template>
                              </el-popover>
                            </label>
                            <template v-if="index == 0">
                              <div>
                                <label style="color: #8a909c; font-weight: normal">申请时间： {{ item.finishTime }}</label>
                              </div>
                            </template>
                            <template v-if="index != 0">
                              <div>
                                <label style="font-weight: normal">接收时间： </label>
                                <label style="color: #8a909c; font-weight: normal">{{ item.createTime }}</label>
                              </div>
                              <div>
                                <label v-if="item.finishTime" style="margin-left: 0px; font-weight: normal">办结时间： </label>
                                <label style="color: #8a909c; font-weight: normal">{{ item.finishTime }}</label>
                              </div>
                            </template>
                            <div v-if="item.comment != undefined">
                              <label v-if="index != 0">
                                审核状态：
                                <a-tag v-if="item.comment.type == 1" class="tag-border-green">通　过</a-tag>
                                <a-tag v-if="item.comment.type == 3 || item.comment.type == 2" class="tag-border-orange">驳　回</a-tag>
                                <a-tag v-if="item.comment.type == 6" class="tag-border-red">不通过</a-tag>
                              </label>
                              <br v-if="index != 0" />
                              <label v-if="index != 0" class="noline">
                                审核意见：
                                <el-popover trigger="hover" placement="top">
                                  <p>{{ item.comment.comment }}</p>
                                  <template slot="reference" class="name-wrapper">
                                    <span style="cursor: pointer; color: #8a909c; font-weight: normal">{{ item.comment.comment }}</span>
                                  </template>
                                </el-popover>
                              </label>
                            </div>
                            <template v-if="item.flowCustomLabelList">
                              <template v-for="(fitem, findex) in item.flowCustomLabelList">
                                <template v-if="item.taskId == fitem.taskId">
                                  <hr style="height: 1px; border: none; background-color: rgba(0,0,0,0.15)" v-if="findex == 0" />
                                  <template v-if="fitem.inputType != 'img'">
                                    <label class="label-font">{{ fitem.inputKey }}：</label>
                                    <label class="label-font" style="color: #8a909c; font-weight: normal">{{ fitem.inputValue }}</label>
                                  </template>
                                  <template v-if="fitem.inputType == 'img'">
                                    <label class="label-font">{{ fitem.inputKey }}：</label>
                                    <img :src="fitem.inputValue" alt="签名图片" style="width: 4.95rem; height: 4.95rem" />
                                  </template>
                                </template>
                              </template>
                            </template>
                          </div>

                          <!-- 会签节点展示 -->
                          <div v-else class="multi-instance-group">
                            <div class="group-header">
                              <span>会签（共 {{ item.subTasks.length }} 人）</span>
                              <a-button type="link" size="small" @click="toggleGroupExpand(item)">{{ item.expanded ? '收起详情' : '查看详情' }}</a-button>
                            </div>
                            <div v-if="item.expanded" class="group-detail">
                              <div v-for="(sub, idx) in item.subTasks" :key="sub.taskId" class="sub-task">
                                <div><strong>办理人：</strong>{{ sub.assigneeName || sub.assigneeId }}</div>
                                <div><strong>审核意见：</strong>{{ sub.comment?.comment || '无' }}</div>
                                <div><strong>办理时间：</strong>{{ sub.finishTime || sub.createTime }}</div>
                                <div><strong>办理结果：</strong>
                                  <a-tag v-if="sub.comment?.type == 1" class="tag-border-green">通过</a-tag>
                                  <a-tag v-if="sub.comment?.type == 3 || sub.comment?.type == 2" class="tag-border-orange">驳回</a-tag>
                                  <a-tag v-if="sub.comment?.type == 6" class="tag-border-red">不通过</a-tag>
                                  <span v-else>-</span>
                                </div>
                                <hr v-if="idx !== item.subTasks.length - 1" />
                              </div>
                            </div>
                          </div>
                        </el-card>
                      </a-timeline-item>
                    </a-timeline>
                  </div>
                </a-card>
              </div>
            </div>
          </div>
          <a-col :span="24">
            <a-row>
              <a-col :span="10"> 
                <a-form-model-item label="所属组织及岗位" prop="organPostId">
                  <a-cascader
                    v-model.trim="formObject.organPostId"
                    :options="options"
                    :show-search="{ filterOption }"
                    placeholder="请选择所属组织及岗位"
                    :style="{ width: '100%', textAlign: 'left' }"
                    @change="onOrganAndJob"
                    :getPopupContainer="triggerNode => triggerNode.parentNode"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item prop="summary" label="概述">
                  <a-input v-emoji v-model="formObject.summary" :max-length="50" placeholder="例: 教学用具" />
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-form-model>
      <hr style="border: 0.5px solid rgba(0, 0, 0, 0.1)" />
      <br />
 
      <fm-generate-form
        :data="jsonData"
        :value="editData"
        ref="generateForm"
        style="padding: 0 20px"
      ></fm-generate-form>

      <a-modal
        title="指定节点审核人"
        :visible="auditUserVisible"
        width="60%"
        @ok="handleOk"
        @cancel="handleCancel"
      >
        <a-form :form="form1" :label-col="{ span: 8 }" :wrapper-col="{ span: 14 }">
          <template v-for="(item, index) in flowApproverSetList">
            <a-form-item :label="item.taskName" :key="index">
              <select-person
                ref="personPick"
                :tabList="userGroupTabList"
                v-model="userGroupObj[item.taskDefKey]"
                width="100%"
              />
            </a-form-item>
          </template>
        </a-form>
      </a-modal>
    </a-spin>
  </div>
</template>

<script>
import {
  queryProcessApplyForm,
  getApplyProcessFormByFormId,
  formFillSave
} from '@/services/processApply';
import { getMyApplyDetailsById, startProcess, editMyApplyDetailsById } from '@/services/myApply';
import {
  nextFlowNode,
  complete,
  saveFlowTrack,
  getFlowRecordById,
  queryFormFillById,
  getWormingScope
} from '@/services/form';
import selectPerson from '@/components/select-person/genera';
import waitdo from '../../dashboard/waitdo/waitdo';

export default {
  components: { selectPerson },
  data() {
    const userGroupTabList = [
      { title: '组织岗位', value: 2 },
      { title: '组织岗位成员', value: 3 }
    ];
    return {
      isLoading: false,
      spinning: false,
      form1: {},
      userGroupTabList,
      userGroupObj: {},
      flowApproverSetList: [],
      procInsId: '',
      sliderbar: false,
      sliderbarShow: false,
      rules: {
        organPostId: [{ required: true, message: '请选择所属组织及岗位' }],
        summary: [{ required: true, message: '请输入概述' }],
      },
      formObject: {
        organPostId: [],
        summary: ''
      },
      fillStatus: '',
      options: [],
      jsonData: { list: [], config: { labelWidth: 100, labelPosition: 'right', size: 'small', customClass: '', ui: 'antd', layout: 'horizontal', labelCol: 3, width: '100%', hideLabel: false, hideErrorMessage: false } },
      versionId: '',
      formName: '',
      checkItem: {},
      userInfo: this.$hdk.userInfo.get(),
      editData: {},
      usersList: {},
      editItem: {},
      query: {},
      flowListRaw: [],      // 原始流转记录（后端返回）
      displayFlowList: [],  // 合并会签后的展示列表
      auditUserVisible: false,
      updateVariable: false,
      newFillData: null,
      organId: '',
      postId: '',
      formVerData: {}
    };
  },
  mounted() {
    this.spinning = true;
    this.query = this.$route.query;
    this.checkItem = JSON.parse(this.$route.query.item);

    if (this.query.type == 1 || this.query.type == 4) {
      this.getCompile(this.checkItem);
    } else {
      this.getApplyProcess(this.checkItem);
    }

    if (this.query.type == 4) {
      this.onloadFlowRecord();
    }

    getWormingScope({
      formId: this.checkItem.formId,
      userId: this.userInfo.userId
    }).then(res => {
      if (res.data.data && res.data.data.length != 0) {
        if (this.organId != null && this.postId != '') {
          this.formObject.organPostId[0] = this.organId;
          this.formObject.organPostId[1] = this.postId;
        } else {
          this.formObject.organPostId[0] = res.data.data[0].organId;
          if (res.data.data[0].postList && res.data.data[0].postList.length != 0) {
            this.formObject.organPostId[1] = res.data.data[0].postList[0].postId;
          }
        }
      }
      this.options = _.map(res.data.data, item => {
        item.postList = _.map(item.postList, subItem => {
          return { label: subItem.postName, value: subItem.postId, children: null };
        });
        return { label: item.organName, value: item.organId, children: item.postList };
      });
      this.spinning = false;
      this.initSqbm([this.formObject.organPostId[0], this.formObject.organPostId[1]])
    });
  },
  methods: {
    // 会签组展开/收起
    toggleGroupExpand(item) {
      this.$set(item, 'expanded', !item.expanded);
    },
    // 处理流转记录：合并会签子任务
    mergeMultiInstanceTasks(flowList) {
      const groupMap = new Map();
      const normalList = [];
      flowList.forEach(item => {
        // 判断是否会签子任务（后端需返回 multiInstance=true 且 multiInstanceGroupId 有值）
        if (item.multiInstance && item.multiInstanceGroupId) {
          const groupId = item.multiInstanceGroupId;
          if (!groupMap.has(groupId)) {
            // 创建组对象，浅拷贝原始属性（排除子任务特有字段）
            const group = {
              ...item,
              subTasks: [],
              multiInstance: true,
              assigneeName: undefined,
              comment: undefined,
              expanded: false
            };
            groupMap.set(groupId, group);
          }
          const group = groupMap.get(groupId);
          group.subTasks.push(item);
          // 更新组的创建时间（取最早）
          if (!group.createTime || (item.createTime && item.createTime < group.createTime)) {
            group.createTime = item.createTime;
          }
          // 更新组的完成时间（取最晚）
          if (!group.finishTime || (item.finishTime && item.finishTime > group.finishTime)) {
            group.finishTime = item.finishTime;
          }
        } else {
          normalList.push(item);
        }
      });
      const groupList = Array.from(groupMap.values());
      // 按创建时间排序（升序）
      const allItems = [...normalList, ...groupList];
      allItems.sort((a, b) => new Date(a.createTime) - new Date(b.createTime));
      return allItems;
    },
    onloadFlowRecord() {
      getFlowRecordById(this.checkItem.processInstanceId).then(res => {
        if (res.data.code == 200) {
          this.flowListRaw = res.data.data.flowList || [];
          // 合并会签子任务
          this.displayFlowList = this.mergeMultiInstanceTasks(this.flowListRaw);

          // 原有逻辑：用最新一条记录的 formDta 回显表单数据
          if (this.flowListRaw.length > 0) {
            let lastItem = this.flowListRaw[this.flowListRaw.length - 1];
            if (lastItem && lastItem.formDta && lastItem.formDta.formData) {
              let formDataJson = JSON.parse(lastItem.formDta.formData);
              let fillDataJson = typeof lastItem.formDta.fillData == 'string'
                ? JSON.parse(lastItem.formDta.fillData)
                : lastItem.formDta.fillData;
              this.$set(this.jsonData, 'list', formDataJson.list);
              this.$set(this.jsonData, 'config', formDataJson.config);
              this.editData = fillDataJson;
              this.$nextTick(() => {
                this.$refs.generateForm.refresh();
                this.$refs.generateForm.setData(this.editData);
              });
            }
          }
        }
      });
    },
    getCompile(item) {
      this.formName = '编辑表单';
      this.editItem = this.checkItem;
      this.usersList = { postData: [], organData: [], userData: [] };
      getMyApplyDetailsById(item).then(res => {
        if (res.data.code === 200) {
          this.jsonData = JSON.parse(res.data.data.formData);
          this.editData = JSON.parse(res.data.data.fillData);
          this.fillStatus = JSON.parse(res.data.data.fillStatus);
          this.organId = res.data.data.organId;
          this.postId = res.data.data.postId;
          this.formObject.summary = res.data.data.summary;
          this.formVerData = {
            sjybm: res.data.data.sjybm,
            sjjbm: res.data.data.sjjbm,
            fillformid: res.data.data.fillformid
          };
          this.$nextTick(() => {
            this.$refs.generateForm.refresh();
            this.$refs.generateForm.setData(this.editData);
          });
        }
      });
    },
    getApplyProcess(item) {
      getApplyProcessFormByFormId(item).then(res => {
        if (res.data.code == 200) {
          if (res.data.data == null) {
            this.$message.error('请设计表单后再发起申请');
            return;
          }
          this.formVerData = res.data.data;
          this.versionId = res.data.data.id;
          this.formName = item.formName;
          this.jsonData = JSON.parse(res.data.data.formData.value);
          this.$nextTick(() => {
            this.$refs?.generateForm?.refresh();
          });
        }
      });
    },
    filterOption(inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1) ||
             path.some(option => option.value.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    },
    onClose() {
      this.$router.go(-1);
    },
    findTreeNodeByType(tree, targetType) {
      const result = [];
      const childKeys = ['list', 'columns'];
      for (const node of tree) {
        if (node.type === targetType) result.push(node);
        for (const key of childKeys) {
          const childNodes = node[key];
          if (childNodes && childNodes.length) {
            result.push(...this.findTreeNodeByType(childNodes, targetType));
          }
        }
      }
      return result;
    },
    async saveDraft() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.$refs.generateForm.getData().then(data => {
            var subData = [];
            if (this.jsonData.list) {
              let subformList = this.findTreeNodeByType(this.jsonData.list, "subform");
              if (subformList && subformList.length > 0) {
                const subFormData = _.map(subformList, (item) => ({
                  linkKey: item.linkKey,
                  sjybm: item.dataSource[0],
                  sjjbm: item.dataSource[1],
                  list: data[item.model]
                }));
                subData.push(subFormData);
              }
              let tableList = this.findTreeNodeByType(this.jsonData.list, "table");
              if (tableList && tableList.length > 0) {
                const subTableData = _.map(tableList, (item) => ({
                  linkKey: item.linkKey,
                  sjybm: item.dataSource[0],
                  sjjbm: item.dataSource[1],
                  list: data[item.model]
                }));
                subData.push(subTableData);
              }
            }
            subData = _.flattenDeep(subData);
            formFillSave({
              formId: this.checkItem.formId,
              formName: this.checkItem.formName,
              sjybm: this.formVerData.sjybm,
              sjjbm: this.formVerData.sjjbm,
              fillformid: this.formVerData.fillformid,
              versionId: this.versionId,
              fillData: data,
              summary: this.formObject.summary,
              organId: this.formObject.organPostId[0],
              postId: this.formObject.organPostId[1],
              subData: subData
            }).then(res => {
              if (res.data.code == 200) {
                this.isLoading = false;
                this.$message.success('保存成功');
                this.onClose();
              }
            }).catch(e => {
              console.log(e);
              this.isLoading = false;
            });
          });
        } else {
          this.isLoading = false;
        }
      });
    },
    async updateSaveDraft() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.$refs.generateForm.getData().then(data => {
            var subData = [];
            if (this.jsonData.list) {
              let subformList = this.findTreeNodeByType(this.jsonData.list, "subform");
              if (subformList && subformList.length > 0) {
                const subFormData = _.map(subformList, (item) => ({
                  linkKey: item.linkKey,
                  sjybm: item.dataSource[0],
                  sjjbm: item.dataSource[1],
                  list: data[item.model]
                }));
                subData.push(subFormData);
              }
              let tableList = this.findTreeNodeByType(this.jsonData.list, "table");
              if (tableList && tableList.length > 0) {
                const subTableData = _.map(tableList, (item) => ({
                  linkKey: item.linkKey,
                  sjybm: item.dataSource[0],
                  sjjbm: item.dataSource[1],
                  list: data[item.model]
                }));
                subData.push(subTableData);
              }
            }
            subData = _.flattenDeep(subData);
            formFillSave({
              id: this.editItem.id,
              formId: this.checkItem.formId,
              formName: this.checkItem.formName,
              sjybm: this.formVerData.sjybm,
              sjjbm: this.formVerData.sjjbm,
              fillformid: this.formVerData.fillformid,
              versionId: this.versionId,
              fillData: data,
              summary: this.formObject.summary,
              organId: this.formObject.organPostId[0],
              postId: this.formObject.organPostId[1],
              subData: subData
            }).then(res => {
              if (res.data.code == 200) {
                this.isLoading = false;
                this.$message.success('保存成功');
                this.onClose();
              }
            }).catch(e => {
              console.log(e);
              this.isLoading = false;
            });
          });
        } else {
          this.isLoading = false;
        }
      });
    },
    initSqbm(value){
      let sqbm = "";
      const options= this.options;
      options.forEach(e=>{
          if(e.value == value[0])
          {
             sqbm = e.label
             this.editData['sqbm']=sqbm
              this.editData['department']=sqbm
            //sqbm = e.label+"/"
           // e.children.forEach(ee=>{
            //  if(ee.value == value[1]){
            //    sqbm+=ee.label 
            //     this.editData['sqbm']=sqbm
            //  }
            //})
          }
      })

      this.$refs.generateForm.setData(this.editData);
    },
    onOrganAndJob(value) {
      const { $set, formObject } = this;
      $set(formObject, 'organId', value[0]);
      $set(formObject, 'postId', value[1]);
      this.formObject.customize = {};
      this.formObject.customize.organId = value[0];
      this.formObject.customize.postId = value[1];
      this.initSqbm(value)
     
      
    },
    async handleSubmit() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.isLoading = true;
          this.$refs.generateForm.getData().then(data => {
            var subData = [];
            if (this.jsonData.list) {
              let subformList = this.findTreeNodeByType(this.jsonData.list, "subform");
              if (subformList && subformList.length > 0) {
                const subFormData = _.map(subformList, (item) => ({
                  linkKey: item.linkKey,
                  sjybm: item.dataSource[0],
                  sjjbm: item.dataSource[1],
                  list: data[item.model]
                }));
                subData.push(subFormData);
              }
              let tableList = this.findTreeNodeByType(this.jsonData.list, "table");
              if (tableList && tableList.length > 0) {
                const subTableData = _.map(tableList, (item) => ({
                  linkKey: item.linkKey,
                  sjybm: item.dataSource[0],
                  sjjbm: item.dataSource[1],
                  list: data[item.model]
                }));
                subData.push(subTableData);
              }
            }
            subData = _.flattenDeep(subData);
            formFillSave({
              formId: this.checkItem.formId,
              formName: this.checkItem.formName,
              sjybm: this.formVerData.sjybm,
              sjjbm: this.formVerData.sjjbm,
              fillformid: this.formVerData.fillformid,
              versionId: this.versionId,
              fillData: data,
              summary: this.formObject.summary,
              organId: this.formObject.organPostId[0],
              postId: this.formObject.organPostId[1],
              subData: subData
            }).then(res => {
              if (res.data.code == 200) {
                this.isLoading = false;
                startProcess({
                  formName: this.checkItem.formName,
                  formId: this.checkItem.formId,
                  versionId: this.versionId,
                  fillData: data,
                  fillId: res.data.data
                }).then(res => {
                  if (res.data.code === 200) {
                    const fileUploadValues = Object.keys(data).filter(key => key.startsWith('fileupload_')).map(key => data[key]);
                    if (fileUploadValues.length === 0) {
                      this.onClickPublishThen(res.data.data);
                    } else {
                      this.$confirm('请确认当前上传的附件是否完整。确认提交后，表单将按当前附件状态同步提交。', '提示', {
                        type: 'info',
                        confirmButtonText: '确认提交',
                        cancelButtonText: '返回编辑'
                      }).then(() => {
                        this.onClickPublishThen(res.data.data);
                      });
                    }
                  }
                });
              } else {
                this.isLoading = false;
                this.$message.error(res.data.message);
              }
            });
          }).catch(e => {
            console.log(e);
            this.isLoading = false;
          });
        } else {
          this.isLoading = false;
        }
      });
    },
    handleOk(e) {
      let nextAuditUserFlag = true;
      this.flowApproverSetList.map(item => {
        let node = this.userGroupObj[item.taskDefKey];
        if (!node || JSON.stringify(node) == '{}' || (node.postData.length == 0 && node.userData.length == 0)) {
          this.$message.info('请选择节点: "' + item.taskName + '" 的审核人');
          nextAuditUserFlag = false;
        }
      });
      if (!nextAuditUserFlag) return;
      let param = {
        procInsId: this.procInsId,
        approverSetMap: this.userGroupObj,
        comment: '发起流程申请',
        processStatus: 1,
        updateVariable: this.updateVariable,
        values: this.newFillData
      };
      this.completeTask(param);
    },
    handleCancel(e) {
      this.auditUserVisible = false;
    },
    getTagColor(type) {
      let colors = [
        { itemVal: 'rgba(255, 152, 6, 0.8)', itemKey: '3' },
        { itemVal: 'rgba(255, 152, 6, 0.8)', itemKey: '2' },
        { itemVal: 'rgba(79, 191, 73, 0.8)', itemKey: '1' },
        { itemVal: 'rgba(220, 33, 39, 0.8)', itemKey: '6' },
        { itemVal: 'rgba(24, 144, 255, 0.8)', itemKey: '0' }
      ];
      return colors.find(item => item.itemKey == type)?.itemVal;
    },
    getCircleColor(item) {
      let col;
      if (item.multiInstance && item.subTasks && item.subTasks.length) {
        // 会签组：取组内第一个子任务的颜色作为组颜色（或自定义）
        col = this.getTagColor(item.subTasks[0]?.comment?.type);
      } else {
        col = this.getTagColor(item.comment?.type);
      }
      if (col == undefined) col = this.getTagColor('0');
      return col;
    },
    formartDept(dept) {
      if (dept) {
        let depts = dept.split('/');
        if (depts.length > 1) return depts[0] + '...';
        else return dept;
      }
    },
    getTagMsg(type) {
      let msg = [
        { itemVal: '驳回', itemKey: '3' },
        { itemVal: '通过', itemKey: '1' },
        { itemVal: '不通过', itemKey: '6' }
      ];
      return msg.find(item => item.itemKey == type)?.itemVal;
    },
    handleSubmit1(isTj) {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.$refs.generateForm.getData().then(data => {
            editMyApplyDetailsById({
              id: this.editItem.id,
              fillData: data,
              formId: this.editItem.formId,
              versionId: this.editItem.versionId,
              copyManData: [],
              summary: this.formObject.summary,
              organId: this.formObject.organPostId[0],
              postId: this.formObject.organPostId[1]
            }).then(res => {
              if (res.data.code == 200) {
                if (isTj) {
                  this.handleSub2();
                } else {
                  this.$message.success('保存成功');
                }
              } else {
                this.$message.error(res.data.message);
              }
            });
          }).catch(e => console.log(e));
        }
      });
    },
    handleSubmit2() {
      this.handleSubmit1(true);
    },
    handleSub2() {
      queryFormFillById({ id: this.checkItem.id }).then(res => {
        const data = res.data.data?.fillData;
        const dataObj = JSON.parse(data);
        const fileUploadValues = Object.keys(dataObj).filter(key => key.startsWith('fileupload_')).map(key => dataObj[key]);
        if (fileUploadValues.length === 0) {
          let formFill = res.data.data;
          let oldData = this.checkItem.fillData.value;
          if (oldData != formFill.fillData && formFill.processInstanceId != null) {
            this.updateVariable = true;
            this.newFillData = JSON.parse(formFill.fillData);
          } else {
            this.updateVariable = false;
          }
          if (formFill != null && formFill.processInstanceId != null) {
            this.onClickPublishThen(formFill.processInstanceId);
          } else {
            this.$refs.addForm.validate(valid => {
              if (valid) {
                startProcess({
                  formName: this.checkItem.formName,
                  formId: this.checkItem.formId,
                  versionId: this.checkItem.versionId,
                  fillData: this.checkItem.fillData.value,
                  fillId: this.checkItem.id
                }).then(res => {
                  if (res.data.code == 200) this.onClickPublishThen(res.data.data);
                });
              }
            });
          }
        } else {
          this.$confirm('请确认当前上传的附件是否完整。确认提交后，表单将按当前附件状态同步提交。', '提示', {
            type: 'info',
            confirmButtonText: '确认提交',
            cancelButtonText: '返回编辑'
          }).then(() => {
            let formFill = res.data.data;
            let oldData = this.checkItem.fillData.value;
            if (oldData != formFill.fillData && formFill.processInstanceId != null) {
              this.updateVariable = true;
              this.newFillData = JSON.parse(formFill.fillData);
            } else {
              this.updateVariable = false;
            }
            if (formFill != null && formFill.processInstanceId != null) {
              this.onClickPublishThen(formFill.processInstanceId);
            } else {
              this.$refs.addForm.validate(valid => {
                if (valid) {
                  startProcess({
                    formName: this.checkItem.formName,
                    formId: this.checkItem.formId,
                    versionId: this.checkItem.versionId,
                    fillData: this.checkItem.fillData.value,
                    fillId: this.checkItem.id
                  }).then(res => {
                    if (res.data.code == 200) this.onClickPublishThen(res.data.data);
                  });
                }
              });
            }
          }).catch(() => {});
        }
      });
    },
    handleSubmit3() {
      this.handleSubmit1(true);
    },
    handleSub3() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.$refs.generateForm.getData().then(data => {
            editMyApplyDetailsById({
              id: this.editItem.id,
              fillData: data,
              formId: this.editItem.formId,
              versionId: this.editItem.versionId,
              copyManData: [],
              summary: this.formObject.summary,
              organId: this.formObject.organPostId[0],
              postId: this.formObject.organPostId[1]
            }).then(res => {
              if (res.data.code == 200) {
                let param = {
                  procInsId: this.checkItem.processInstanceId,
                  nextNodeCliamUserId: '',
                  nextNodeUserType: '',
                  comment: '发起流程申请',
                  processStatus: 1,
                  instValues: { fillData: this.checkItem.fillData.value }
                };
                this.completeTask(param);
              } else {
                this.$message.error(res.data.message);
              }
            });
          }).catch(e => console.log(e));
        }
      });
    },
    async onClickPublishThen(procInsId) {
      this.procInsId = procInsId;
      const res = await nextFlowNode({ procInsId: this.procInsId });
      if (res.data.code == 200) {
        let param = {
          procInsId: this.procInsId,
          comment: '发起流程申请',
          processStatus: 1,
          updateVariable: this.updateVariable,
          values: this.newFillData
        };
        if (res.data.data == undefined) {
          // 无数据，直接完成
        } else if (Object.keys(res.data.data).length > 0) {
          if (res.data.message == '自由选择') {
            this.auditUserVisible = true;
            this.flowApproverSetList = res.data.data;
          } else {
            this.completeTask(param);
          }
        }
      }
    },
    completeTask(param) {
      complete(param).then(res => {
        if (res.data.code == 200) {
          this.$message.success('提交成功');
          this.updateVariable = false;
          this.newFillData = null;
          this.onClose();
        }
      });
    },
    clickChange() {
      this.sliderbar = !this.sliderbar;
      this.sliderbarShow = true;
    }
  }
};
</script>

<style scoped lang="less">
/deep/ .ant-form-item {
  margin-top: 14px;
  margin-bottom: 14px;
}
.sliderbar-off {
  width: 40px;
  border-radius: 10px 0 0 10px;
  float: left;
  cursor: pointer;
  height: 120px;
  padding: 5px 10px;
  color: white;
  background-color: #1890ff;
}
.right-open {
  width: 500px;
  height: 100%;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  animation: exampleRightOpen 0.5s ease-out;
}
.right-close {
  width: 0px;
  height: 100%;
  display: flex;
  overflow: hidden;
  animation: exampleRightClose 0.5s ease-in-out;
  white-space: nowrap;
}
.right-card::-webkit-scrollbar-thumb {
  border-radius: 0px !important;
  background-color: #fff;
}
.right-card::-webkit-scrollbar-track {
  border-radius: 0px !important;
  background: #fff;
}
.noline {
  white-space: normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
/deep/ .right-card .ant-card-body {
  height: calc(100vh - 200px);
  overflow-y: scroll;
}
.multi-instance-group {
  .group-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
  }
  .group-detail {
    margin-top: 8px;
    border-top: 1px solid #eee;
    padding-top: 8px;
    .sub-task {
      margin-bottom: 8px;
    }
  }
}
</style>